import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';
import { RegisteredRoute } from '@wilson/interfaces';
import { LocationIdToLocationPipe } from '@wilson/locations';
import { PipesModule } from '@wilson/pipes';
import { RoutesService } from '@wilson/route';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { Observable } from 'rxjs/dist/types';
import { SharedUserQualificationDetailViewResponse } from '../../../../gateways/shared-user-qualifications-v2.gateway';
import {
  faLocationDot,
  faCircle,
  faFlag,
} from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'wilson-route-knowledge-via-points',
  templateUrl: './route-knowledge-via-points.component.html',
  styleUrls: ['./route-knowledge-via-points.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslatePipe,
    FontAwesomeModule,
    NzCollapseModule,
    LocationIdToLocationPipe,
    PipesModule,
  ],
})
export class RouteKnowledgeViaPointsComponent {
  private readonly routesService = inject(RoutesService);

  private _routeId!: string | null;
  @Input() set routeId(newRouteId: string | null) {
    this._routeId = newRouteId;
    this.updateRouteStream();
  }
  get routeId(): string | null {
    return this._routeId;
  }
  @Input()
  sharedRouteData!: SharedUserQualificationDetailViewResponse['qualification']['route'];

  protected route$!: Observable<RegisteredRoute>;

  readonly faLocationDot = faLocationDot;
  readonly faCircle = faCircle;
  readonly faFlag = faFlag;

  private updateRouteStream(): void {
    if (this.routeId) {
      this.route$ = this.routesService.getRoute(this.routeId);
    }
  }
}
